const ALLOWED_RESUME_CALLBACKS = new Set([
  "https://resume.arialabs.co/auth/callback",
  "https://resume.primefolio.me/auth/callback",
  "http://127.0.0.1:4177/auth/callback",
  "http://localhost:4177/auth/callback",
]);

export function isAllowedResumeCallback(returnTo) {
  return ALLOWED_RESUME_CALLBACKS.has(returnTo);
}
